import "../phaser.min.js";
import Player from "../Includes/Player.js";
import NameGenerator from "../Includes/NameGenerator.js";
import Common from "../Includes/Common.js";
import CarSelection from "./CarSelection";
import Quiz from "./Quiz";

class SelectionScene extends Phaser.Scene {
    constructor() {
        super('SelectionScene');
        this.carSelectionActive = false;
        this.nameGenerator = new NameGenerator();
        this.common = new Common();
    }

    init() {
        this.username = this.nameGenerator.generateName();
        this.carIndex = 0;
        this.colorIndex = 0;
        this.progress = 0;
        this.district = '';
        this.isTransitioning = false;
    }

    preload() {

    }

    create() {

        this.acceptSFX = this.sound.add('accept', {volume: 0.1});
        this.nextSFX = this.sound.add('next', {volume: 0.1});
        this.scene.add('CarSelection', CarSelection, true);
        this.scene.launch('CarSelection');
        this.scene.moveBelow('Ui', 'CarSelection');

        this.scrollingScene = this.scene.get('ReflectionBackground');
        this.scrollingScene.cameras.main.zoomTo(1.5, 1000);

        this.carSelectionScene = this.scene.get('CarSelection');
        this.carSelectionScene.cameras.main.zoomTo(1.5, 1000);

        this.selectedCar = this.carSelectionScene.selectedCar;
        this.carSelectionScene.events.on('carSelectionActive', (value) => {
            this.carSelectionActive = value;
        })

        this.music = this.sound.add('intro-music', {volume: this.common.bgMusicVolume, loop: true});
        this.music.play();

        const headingY = -40;
        const headingStyle = {fontFamily: this.common.font, fontSize: 40, fontWeight: 100, color: this.common.blue};
        const valueStyle = {fontFamily: this.common.font, fontSize: 52, fontWeight: 100, color: this.common.blue}


        const carChoiceY = 70;
        const colorChoiceY = carChoiceY + 80;
        // Choose Car Box
        this.carBox = this.add.sprite(0, -75, 'ui', 'car-box').setScale(this.common.gameScale).setOrigin(0.5, 0);
        this.chooseText = this.add.text(0, headingY, 'Choose your car:', headingStyle).setOrigin(0.5, 0.5);
        this.carText = this.add.text(0, carChoiceY, 'Car', valueStyle).setOrigin(0.5)
        this.backButtonCar = this.add.sprite(-150, carChoiceY, 'ui', 'arrow-left-nb').setScale(this.common.gameScale)
        this.forwardButtonCar = this.add.sprite(150, carChoiceY, 'ui', 'arrow-right-nb').setScale(this.common.gameScale)
        this.colorText = this.add.text(0, colorChoiceY, 'Color', valueStyle).setOrigin(0.5)
        this.backButtonColor = this.add.sprite(-150, colorChoiceY, 'ui', 'left-arrow').setScale(this.common.gameScale)
        this.forwardButtonColor = this.add.sprite(150, colorChoiceY, 'ui', 'arrow-right').setScale(this.common.gameScale)
        this.chooseCarContainer = this.add.container((-this.scale.width) * 2, this.scale.height / 12 * 7, [this.carBox, this.chooseText, this.carText, this.backButtonCar, this.forwardButtonCar, this.colorText, this.backButtonColor, this.forwardButtonColor])
        this.chooseCarContainer.setVisible(false);

        //Name Box
        this.nameBox = this.add.sprite(0, -75, 'ui', 'name-box').setScale(this.common.gameScale).setOrigin(0.5, 0);
        this.nameHeading = this.add.text(0, headingY, 'Generate screen name:', headingStyle).setOrigin(0.5, 0.5)
        this.nameText = this.add.text(0, 0, this.username, valueStyle).setOrigin(0.5, 0)
        this.nameSubmitButton = this.add.sprite(272, 25, 'ui', 'refresh-normal').setScale(3).setOrigin(0.5)
        this.nameSubmitButton.setInteractive({cursor: 'pointer'})
        this.nameContainer = this.add.container((-this.scale.width) * 2, this.scale.height / 12 * 7, [this.nameBox, this.nameHeading, this.nameText, this.nameSubmitButton])
                .setVisible(false);


        // School District
        this.schoolBox = this.add.sprite(0, -75, 'ui', 'school-box').setScale(this.common.gameScale).setOrigin(0.5, 0);
        this.schoolText = this.add.text(0, headingY, 'Select school:', headingStyle).setOrigin(0.5, 0.5);
        this.schoolSelect = this.add.dom(0, 20).createFromHTML(
                '<select id="districtSelect" class="district-select">' +
                '<optgroup><option value="">-- Select a School --</option>' +
                '<option value="Homeschooled">Homeschooled</option>' +
                '<option value="Abundant Life School – Sherwood">Abundant Life School – Sherwood</option>' +
                '<option value="Academies At Rivercrest High School">Academies At Rivercrest High School</option>' +
                '<option value="Access Academy">Access Academy</option>' +
                '<option value="Acorn High School">Acorn High School</option>' +
                '<option value="Agee Lierly Life Preparation Services School">Agee Lierly Life Preparation Services School</option>' +
                '<option value="All Saints Lutheran School">All Saints Lutheran School</option>' +
                '<option value="Alma High School">Alma High School</option>' +
                '<option value="Alpena High School">Alpena High School</option>' +
                '<option value="Arkadelphia High School">Arkadelphia High School</option>' +
                '<option value="Arkansas Arts Academy High School">Arkansas Arts Academy High School</option>' +
                '<option value="Arkansas Christian Academy">Arkansas Christian Academy</option>' +
                '<option value="Arkansas Connections Academy High">Arkansas Connections Academy High</option>' +
                '<option value="Arkansas Consolidate High School - Vera Lloyd">Arkansas Consolidate High School - Vera Lloyd</option>' +
                '<option value="Arkansas Consolidated High School - Lewisville">Arkansas Consolidated High School - Lewisville</option>' +
                '<option value="Arkansas Consolidated High School-Alexander">Arkansas Consolidated High School-Alexander</option>' +
                '<option value="Arkansas Consolidated High School-Dermott">Arkansas Consolidated High School-Dermott</option>' +
                '<option value="Arkansas Consolidated High School-Harrisburg">Arkansas Consolidated High School-Harrisburg</option>' +
                '<option value="Arkansas Consolidated High School-Mansfield">Arkansas Consolidated High School-Mansfield</option>' +
                '<option value="Arkansas High School">Arkansas High School</option>' +
                '<option value="Arkansas School for the Deaf And Blind High">Arkansas School for the Deaf And Blind High</option>' +
                '<option value="Arkansas Virtual Academy High School">Arkansas Virtual Academy High School</option>' +
                '<option value="Armorel High School">Armorel High School</option>' +
                '<option value="Ashdown High School">Ashdown High School</option>' +
                '<option value="Atkins High School">Atkins High School</option>' +
                '<option value="Augusta High School">Augusta High School</option>' +
                '<option value="Bald Knob High School">Bald Knob High School</option>' +
                '<option value="Baptist Preparatory School">Baptist Preparatory School</option>' +
                '<option value="Barton High School">Barton High School</option>' +
                '<option value="Batesville High School Charter">Batesville High School Charter</option>' +
                '<option value="Bauxite High School">Bauxite High School</option>' +
                '<option value="Bay High School">Bay High School</option>' +
                '<option value="Bearden High School">Bearden High School</option>' +
                '<option value="Beebe High School">Beebe High School</option>' +
                '<option value="Benton High School">Benton High School</option>' +
                '<option value="Bentonville High School">Bentonville High School</option>' +
                '<option value="Bentonville West High School">Bentonville West High School</option>' +
                '<option value="Bergman High School">Bergman High School</option>' +
                '<option value="Berryville High School">Berryville High School</option>' +
                '<option value="Bible Baptist Christian School">Bible Baptist Christian School</option>' +
                '<option value="Bigelow High School">Bigelow High School</option>' +
                '<option value="Bismarck High School">Bismarck High School</option>' +
                '<option value="Blevins High School">Blevins High School</option>' +
                '<option value="Blytheville High School">Blytheville High School</option>' +
                '<option value="Booneville High School">Booneville High School</option>' +
                '<option value="Bradford High School">Bradford High School</option>' +
                '<option value="Bradley High School">Bradley High School</option>' +
                '<option value="Brinkley High School">Brinkley High School</option>' +
                '<option value="Brookland High School">Brookland High School</option>' +
                '<option value="Bryant High School">Bryant High School</option>' +
                '<option value="Buffalo Island Central High School">Buffalo Island Central High School</option>' +
                '<option value="Cabot High School">Cabot High School</option>' +
                '<option value="Cabot Panther Academy">Cabot Panther Academy</option>' +
                '<option value="Caddo Academy">Caddo Academy</option>' +
                '<option value="Calico Rock High School">Calico Rock High School</option>' +
                '<option value="Calvary Academy">Calvary Academy</option>' +
                '<option value="Calvary Christian School">Calvary Christian School</option>' +
                '<option value="Camden Fairview High School">Camden Fairview High School</option>' +
                '<option value="Carlisle High School">Carlisle High School</option>' +
                '<option value="Catholic High School for Boys">Catholic High School for Boys</option>' +
                '<option value="Cave City High Career & Collegiate Preparatory School">Cave City High Career & Collegiate Preparatory School</option>' +
                '<option value="Cedar Heights Christian Academy">Cedar Heights Christian Academy</option>' +
                '<option value="Cedar Ridge High School">Cedar Ridge High School</option>' +
                '<option value="Cedarville High School">Cedarville High School</option>' +
                '<option value="Center Hill School">Center Hill School</option>' +
                '<option value="Centerpoint High School">Centerpoint High School</option>' +
                '<option value="Central Arkansas Christian Schools">Central Arkansas Christian Schools</option>' +
                '<option value="Central High School">Central High School</option>' +
                '<option value="Central High School">Central High School</option>' +
                '<option value="Charleston High School">Charleston High School</option>' +
                '<option value="Christian Ministries Academy">Christian Ministries Academy</option>' +
                '<option value="Clarendon High School">Clarendon High School</option>' +
                '<option value="Clark County Christian Academy">Clark County Christian Academy</option>' +
                '<option value="Clarksville High School">Clarksville High School</option>' +
                '<option value="Clear Spring School">Clear Spring School</option>' +
                '<option value="Clinton High School">Clinton High School</option>' +
                '<option value="Columbia Christian School">Columbia Christian School</option>' +
                '<option value="Compass Academy">Compass Academy</option>' +
                '<option value="Concord High School">Concord High School</option>' +
                '<option value="Conway Christian School">Conway Christian School</option>' +
                '<option value="Conway High School">Conway High School</option>' +
                '<option value="Corning High School">Corning High School</option>' +
                '<option value="Cossatot River High School">Cossatot River High School</option>' +
                '<option value="Cotter High School">Cotter High School</option>' +
                '<option value="County Line High School">County Line High School</option>' +
                '<option value="Creative Action Team School">Creative Action Team School</option>' +
                '<option value="Cross County High School A New Tech School">Cross County High School A New Tech School</option>' +
                '<option value="CrossPointe Preparatory School">CrossPointe Preparatory School</option>' +
                '<option value="Crossett High School">Crossett High School</option>' +
                '<option value="Crowley\'s Ridge Academy">Crowley\'s Ridge Academy</option>' +
                '<option value="Cstp Civilian Student Training Program">Cstp Civilian Student Training Program</option>' +
                '<option value="Cutter-Morning Star High School">Cutter-Morning Star High School</option>' +
                '<option value="Danville High School">Danville High School</option>' +
                '<option value="Dardanelle High School">Dardanelle High School</option>' +
                '<option value="Decatur High School">Decatur High School</option>' +
                '<option value="Deer K-12 School">Deer K-12 School</option>' +
                '<option value="Dequeen High School">Dequeen High School</option>' +
                '<option value="Dermott High School">Dermott High School</option>' +
                '<option value="Des Arc High School">Des Arc High School</option>' +
                '<option value="Dewitt High School">Dewitt High School</option>' +
                '<option value="Dierks High School">Dierks High School</option>' +
                '<option value="Don Tyson School of Innovation">Don Tyson School of Innovation</option>' +
                '<option value="Dover High School">Dover High School</option>' +
                '<option value="Drew Central High School">Drew Central High School</option>' +
                '<option value="Dumas High School">Dumas High School</option>' +
                '<option value="Earle Virtual High School">Earle Virtual High School</option>' +
                '<option value="East Poinsett County High School">East Poinsett County High School</option>' +
                '<option value="El Dorado High School">El Dorado High School</option>' +
                '<option value="Elkins High School">Elkins High School</option>' +
                '<option value="Emerson High School">Emerson High School</option>' +
                '<option value="England High School">England High School</option>' +
                '<option value="Episcopal Collegiate School">Episcopal Collegiate School</option>' +
                '<option value="Estem High School">Estem High School</option>' +
                '<option value="Eureka Springs High School">Eureka Springs High School</option>' +
                '<option value="Exalt Academy High School">Exalt Academy High School</option>' +
                '<option value="Farmington High School">Farmington High School</option>' +
                '<option value="Fayetteville Christian School">Fayetteville Christian School</option>' +
                '<option value="Fayetteville High School">Fayetteville High School</option>' +
                '<option value="Fayetteville Virtual Academy A District Conversion Charter School">Fayetteville Virtual Academy A District Conversion Charter School</option>' +
                '<option value="Flippin High School">Flippin High School</option>' +
                '<option value="Fordyce High School">Fordyce High School</option>' +
                '<option value="Foreman High School">Foreman High School</option>' +
                '<option value="Forrest City High School">Forrest City High School</option>' +
                '<option value="Fort Smith Virtual Academy">Fort Smith Virtual Academy</option>' +
                '<option value="Fouke High School">Fouke High School</option>' +
                '<option value="Founders Classical Academies of Arkansas High School Rogers">Founders Classical Academies of Arkansas High School Rogers</option>' +
                '<option value="Founders Classical Academies of Arkansas West Little Rock">Founders Classical Academies of Arkansas West Little Rock</option>' +
                '<option value="Fountain Lake High School">Fountain Lake High School</option>' +
                '<option value="Future School of Fort Smith">Future School of Fort Smith</option>' +
                '<option value="Garrett Memorial Christian School">Garrett Memorial Christian School</option>' +
                '<option value="Genoa Central High School">Genoa Central High School</option>' +
                '<option value="Gentry High School">Gentry High School</option>' +
                '<option value="Glen Rose High School">Glen Rose High School</option>' +
                '<option value="Gosnell High School">Gosnell High School</option>' +
                '<option value="Gospel Light Christian School">Gospel Light Christian School</option>' +
                '<option value="Graduate Arkansas Charter High">Graduate Arkansas Charter High</option>' +
                '<option value="Grand Prairie Evangelical Methodist School">Grand Prairie Evangelical Methodist School</option>' +
                '<option value="Gravette High School">Gravette High School</option>' +
                '<option value="Green Forest High School">Green Forest High School</option>' +
                '<option value="Greenbrier High School">Greenbrier High School</option>' +
                '<option value="Greene Cty Tech High School">Greene Cty Tech High School</option>' +
                '<option value="Greene Cty Tech Junior High School">Greene Cty Tech Junior High School</option>' +
                '<option value="Greenland High School">Greenland High School</option>' +
                '<option value="Greenwood High School">Greenwood High School</option>' +
                '<option value="Gurdon High School">Gurdon High School</option>' +
                '<option value="Guy Berry College And Career Academy">Guy Berry College And Career Academy</option>' +
                '<option value="Guy-Perkins High School">Guy-Perkins High School</option>' +
                '<option value="Haas Hall Academy">Haas Hall Academy</option>' +
                '<option value="Haas Hall Academy Fort Smith">Haas Hall Academy Fort Smith</option>' +
                '<option value="Haas Hall Academy Jones Center">Haas Hall Academy Jones Center</option>' +
                '<option value="Haas Hall Academy Rogers">Haas Hall Academy Rogers</option>' +
                '<option value="Haas Hall Bentonville">Haas Hall Bentonville</option>' +
                '<option value="Hackett High School">Hackett High School</option>' +
                '<option value="Hall High School - West Soi">Hall High School - West Soi</option>' +
                '<option value="Hamburg High School">Hamburg High School</option>' +
                '<option value="Hampton High School">Hampton High School</option>' +
                '<option value="Har-Ber High School">Har-Ber High School</option>' +
                '<option value="Harding Academy">Harding Academy</option>' +
                '<option value="Harmony Grove High School">Harmony Grove High School</option>' +
                '<option value="Harmony Grove High School">Harmony Grove High School</option>' +
                '<option value="Harrisburg High School">Harrisburg High School</option>' +
                '<option value="Harrison High School">Harrison High School</option>' +
                '<option value="Hazen High School">Hazen High School</option>' +
                '<option value="Heber Springs High School">Heber Springs High School</option>' +
                '<option value="Hector High School">Hector High School</option>' +
                '<option value="Hermitage High School">Hermitage High School</option>' +
                '<option value="Highland High School">Highland High School</option>' +
                '<option value="Hillcrest High School">Hillcrest High School</option>' +
                '<option value="Hope High School">Hope High School</option>' +
                '<option value="Horatio High School">Horatio High School</option>' +
                '<option value="Hot Springs World Class High School">Hot Springs World Class High School</option>' +
                '<option value="Hoxie High School">Hoxie High School</option>' +
                '<option value="Huntsville High School">Huntsville High School</option>' +
                '<option value="Institute for the Creative Arts School">Institute for the Creative Arts School</option>' +
                '<option value="Ischool Virtual Academy of Arkansas">Ischool Virtual Academy of Arkansas</option>' +
                '<option value="Izard County Consolidated High School">Izard County Consolidated High School</option>' +
                '<option value="Jacksonville Christian Academy">Jacksonville Christian Academy</option>' +
                '<option value="Jacksonville High School">Jacksonville High School</option>' +
                '<option value="Jacksonville Lighthouse High School">Jacksonville Lighthouse High School</option>' +
                '<option value="Jasper High School">Jasper High School</option>' +
                '<option value="Jessieville High School">Jessieville High School</option>' +
                '<option value="Joe T. Robinson High School">Joe T. Robinson High School</option>' +
                '<option value="Junction City High School">Junction City High School</option>' +
                '<option value="Kingston High School">Kingston High School</option>' +
                '<option value="Kipp Blytheville Collegiate High School">Kipp Blytheville Collegiate High School</option>' +
                '<option value="Kipp:delta Collegiate High School">Kipp:delta Collegiate High School</option>' +
                '<option value="Kirby High School">Kirby High School</option>' +
                '<option value="Lafayette County High School">Lafayette County High School</option>' +
                '<option value="Lake Hamilton High School">Lake Hamilton High School</option>' +
                '<option value="Lakeside High School">Lakeside High School</option>' +
                '<option value="Lakeside High School">Lakeside High School</option>' +
                '<option value="Lamar High School">Lamar High School</option>' +
                '<option value="Lavaca High School">Lavaca High School</option>' +
                '<option value="Lead Hill High School">Lead Hill High School</option>' +
                '<option value="Lee High School">Lee High School</option>' +
                '<option value="Legacy Academy">Legacy Academy</option>' +
                '<option value="Life Way Christian School">Life Way Christian School</option>' +
                '<option value="Lighthouse Christian Academy">Lighthouse Christian Academy</option>' +
                '<option value="Lincoln High School">Lincoln High School</option>' +
                '<option value="Lisa Academy Arkansas Hybrid School">Lisa Academy Arkansas Hybrid School</option>' +
                '<option value="Lisa Academy North High School">Lisa Academy North High School</option>' +
                '<option value="Lisa Academy West High  School">Lisa Academy West High  School</option>' +
                '<option value="Little Rock Christian Academy">Little Rock Christian Academy</option>' +
                '<option value="Little Rock Southwest  High School">Little Rock Southwest  High School</option>' +
                '<option value="Lonoke High School">Lonoke High School</option>' +
                '<option value="Magazine High School">Magazine High School</option>' +
                '<option value="Magnet Cove High School">Magnet Cove High School</option>' +
                '<option value="Magnolia High School">Magnolia High School</option>' +
                '<option value="Malvern High School">Malvern High School</option>' +
                '<option value="Mammoth Spring High School">Mammoth Spring High School</option>' +
                '<option value="Manila High School">Manila High School</option>' +
                '<option value="Mansfield High School">Mansfield High School</option>' +
                '<option value="Maranatha Baptist Christian School">Maranatha Baptist Christian School</option>' +
                '<option value="Marion High School">Marion High School</option>' +
                '<option value="Marked Tree High School">Marked Tree High School</option>' +
                '<option value="Marmaduke High School">Marmaduke High School</option>' +
                '<option value="Marshall High School">Marshall High School</option>' +
                '<option value="Marvell Academy">Marvell Academy</option>' +
                '<option value="Marvell-Elaine High School">Marvell-Elaine High School</option>' +
                '<option value="Maumelle Charter High School">Maumelle Charter High School</option>' +
                '<option value="Maumelle High School">Maumelle High School</option>' +
                '<option value="Mayflower High School">Mayflower High School</option>' +
                '<option value="Maynard High School">Maynard High School</option>' +
                '<option value="McCrory High School">McCrory High School</option>' +
                '<option value="McGehee High School">McGehee High School</option>' +
                '<option value="Melbourne High School">Melbourne High School</option>' +
                '<option value="Mena High School">Mena High School</option>' +
                '<option value="Midland High School">Midland High School</option>' +
                '<option value="Mills University Studies High School">Mills University Studies High School</option>' +
                '<option value="Miner Academy">Miner Academy</option>' +
                '<option value="Mineral Springs High School">Mineral Springs High School</option>' +
                '<option value="Monticello High School">Monticello High School</option>' +
                '<option value="Morrilton Senior High School">Morrilton Senior High School</option>' +
                '<option value="Mount Ida High School">Mount Ida High School</option>' +
                '<option value="Mount St. Mary Academy">Mount St. Mary Academy</option>' +
                '<option value="Mountain Home Career Academies">Mountain Home Career Academies</option>' +
                '<option value="Mountain Home Christian Academy">Mountain Home Christian Academy</option>' +
                '<option value="Mountain Pine High School">Mountain Pine High School</option>' +
                '<option value="Mountain View High School">Mountain View High School</option>' +
                '<option value="Mountainburg High School">Mountainburg High School</option>' +
                '<option value="Mt. Judea K-12 School">Mt. Judea K-12 School</option>' +
                '<option value="Mt. Vernon Enola High School">Mt. Vernon Enola High School</option>' +
                '<option value="Mulberry High School">Mulberry High School</option>' +
                '<option value="Murfreesboro High School">Murfreesboro High School</option>' +
                '<option value="Nashville High School">Nashville High School</option>' +
                '<option value="Nemo Vista High School">Nemo Vista High School</option>' +
                '<option value="Nettleton High School">Nettleton High School</option>' +
                '<option value="Nevada High  School">Nevada High  School</option>' +
                '<option value="New Life Christian Academy">New Life Christian Academy</option>' +
                '<option value="Norfork High School">Norfork High School</option>' +
                '<option value="North Little Rock Center of Excellence">North Little Rock Center of Excellence</option>' +
                '<option value="North Little Rock High School">North Little Rock High School</option>' +
                '<option value="Northside High School">Northside High School</option>' +
                '<option value="Oark High School">Oark High School</option>' +
                '<option value="Oden Schools">Oden Schools</option>' +
                '<option value="Omaha High School">Omaha High School</option>' +
                '<option value="Osceola High School">Osceola High School</option>' +
                '<option value="Ouachita High School">Ouachita High School</option>' +
                '<option value="Ozark Adventist Academy">Ozark Adventist Academy</option>' +
                '<option value="Ozark Catholic Academy">Ozark Catholic Academy</option>' +
                '<option value="Ozark Jr Sr High School">Ozark Jr Sr High School</option>' +
                '<option value="Ozark Mountain High School">Ozark Mountain High School</option>' +
                '<option value="Palestine-Wheatley Senior High">Palestine-Wheatley Senior High</option>' +
                '<option value="Pangburn High School">Pangburn High School</option>' +
                '<option value="Paragould High School">Paragould High School</option>' +
                '<option value="Paris High School">Paris High School</option>' +
                '<option value="Parkers Chapel High School">Parkers Chapel High School</option>' +
                '<option value="Parkview Magnet High School">Parkview Magnet High School</option>' +
                '<option value="Pea Ridge High School">Pea Ridge High School</option>' +
                '<option value="Perryville High School">Perryville High School</option>' +
                '<option value="Piggott High School">Piggott High School</option>' +
                '<option value="Pine Bluff High School">Pine Bluff High School</option>' +
                '<option value="Pocahontas High School">Pocahontas High School</option>' +
                '<option value="Polk County Virtual Academy">Polk County Virtual Academy</option>' +
                '<option value="Pottsville High School">Pottsville High School</option>' +
                '<option value="Poyen High School">Poyen High School</option>' +
                '<option value="Prairie Grove High School">Prairie Grove High School</option>' +
                '<option value="Premier High School Online">Premier High School Online</option>' +
                '<option value="Premier High School of Fayetteville">Premier High School of Fayetteville</option>' +
                '<option value="Premier High School of Fort Smith">Premier High School of Fort Smith</option>' +
                '<option value="Premier High School of Little Rock">Premier High School of Little Rock</option>' +
                '<option value="Premier High School of North Little Rock">Premier High School of North Little Rock</option>' +
                '<option value="Premier High School of Russellville">Premier High School of Russellville</option>' +
                '<option value="Premier High School of Springdale">Premier High School of Springdale</option>' +
                '<option value="Premier High School of Texarkana">Premier High School of Texarkana</option>' +
                '<option value="Prescott High School">Prescott High School</option>' +
                '<option value="Private School">Private School</option>' +
                '<option value="Providence Classical Christian Academy Upper School Campus">Providence Classical Christian Academy Upper School Campus</option>' +
                '<option value="Pulaski Academy">Pulaski Academy</option>' +
                '<option value="Quitman High School">Quitman High School</option>' +
                '<option value="Raymond F Orr Learning Academy">Raymond F Orr Learning Academy</option>' +
                '<option value="Rector High School">Rector High School</option>' +
                '<option value="Ridgefield Christian School">Ridgefield Christian School</option>' +
                '<option value="Rison High School">Rison High School</option>' +
                '<option value="Riverside High School">Riverside High School</option>' +
                '<option value="Riverview Baptist Christian School">Riverview Baptist Christian School</option>' +
                '<option value="Riverview High School">Riverview High School</option>' +
                '<option value="Rogers Academy of Leadership And Innovation">Rogers Academy of Leadership And Innovation</option>' +
                '<option value="Rogers Heritage High School">Rogers Heritage High School</option>' +
                '<option value="Rogers High School">Rogers High School</option>' +
                '<option value="Rose Bud High School">Rose Bud High School</option>' +
                '<option value="Rural Special High School">Rural Special High School</option>' +
                '<option value="Russellville High School">Russellville High School</option>' +
                '<option value="Sacred Heart Catholic School">Sacred Heart Catholic School</option>' +
                '<option value="Salem High School">Salem High School</option>' +
                '<option value="Scott Charter School">Scott Charter School</option>' +
                '<option value="Scranton High School">Scranton High School</option>' +
                '<option value="Searcy High School">Searcy High School</option>' +
                '<option value="Sheridan High School">Sheridan High School</option>' +
                '<option value="Shiloh Christian School – Rogers Campus">Shiloh Christian School – Rogers Campus</option>' +
                '<option value="Shiloh Christian School – Springdale Campus">Shiloh Christian School – Springdale Campus</option>' +
                '<option value="Shirley High School">Shirley High School</option>' +
                '<option value="Siloam Springs High School">Siloam Springs High School</option>' +
                '<option value="Sloan-Hendrix High School">Sloan-Hendrix High School</option>' +
                '<option value="Smackover High School">Smackover High School</option>' +
                '<option value="South Side High School">South Side High School</option>' +
                '<option value="Southside Charter High School">Southside Charter High School</option>' +
                '<option value="Southside High School">Southside High School</option>' +
                '<option value="Southwest Christian Academy">Southwest Christian Academy</option>' +
                '<option value="Spring Hill High School">Spring Hill High School</option>' +
                '<option value="Springdale High School">Springdale High School</option>' +
                '<option value="St. Joseph Catholic School">St. Joseph Catholic School</option>' +
                '<option value="St. Paul High School">St. Paul High School</option>' +
                '<option value="Star City High School">Star City High School</option>' +
                '<option value="Strong-Huttig Schools">Strong-Huttig Schools</option>' +
                '<option value="Stuttgart High School">Stuttgart High School</option>' +
                '<option value="Sylvan Hills High School">Sylvan Hills High School</option>' +
                '<option value="Taylor High School">Taylor High School</option>' +
                '<option value="Thaden School">Thaden School</option>' +
                '<option value="The Academies At Jonesboro High School">The Academies At Jonesboro High School</option>' +
                '<option value="The Academies At Newport High School">The Academies At Newport High School</option>' +
                '<option value="The Academies of West Memphis Charter School">The Academies of West Memphis Charter School</option>' +
                '<option value="The New School">The New School</option>' +
                '<option value="Timbo High School">Timbo High School</option>' +
                '<option value="Trumann High School">Trumann High School</option>' +
                '<option value="Tuckerman High School">Tuckerman High School</option>' +
                '<option value="Two Rivers High School">Two Rivers High School</option>' +
                '<option value="Umpire K-12 School">Umpire K-12 School</option>' +
                '<option value="Union Christian Academy">Union Christian Academy</option>' +
                '<option value="Valley Christian School">Valley Christian School</option>' +
                '<option value="Valley Springs High School">Valley Springs High School</option>' +
                '<option value="Valley View High School">Valley View High School</option>' +
                '<option value="Van Buren High School">Van Buren High School</option>' +
                '<option value="Victory Christian School">Victory Christian School</option>' +
                '<option value="Vilonia High School">Vilonia High School</option>' +
                '<option value="Vilonia Pathways Academy">Vilonia Pathways Academy</option>' +
                '<option value="Viola High School">Viola High School</option>' +
                '<option value="Waldron High School">Waldron High School</option>' +
                '<option value="Walnut Ridge High School">Walnut Ridge High School</option>' +
                '<option value="Warren High School">Warren High School</option>' +
                '<option value="Watson Chapel High School">Watson Chapel High School</option>' +
                '<option value="West Fork High School">West Fork High School</option>' +
                '<option value="West Memphis Christian School">West Memphis Christian School</option>' +
                '<option value="West Side Christian School">West Side Christian School</option>' +
                '<option value="West Side High School">West Side High School</option>' +
                '<option value="Western Yell County High School">Western Yell County High School</option>' +
                '<option value="Westside High School">Westside High School</option>' +
                '<option value="Westside High School">Westside High School</option>' +
                '<option value="White County Central High School">White County Central High School</option>' +
                '<option value="White Hall High School">White Hall High School</option>' +
                '<option value="Wonderview High School">Wonderview High School</option>' +
                '<option value="Woodlawn High School">Woodlawn High School</option>' +
                '<option value="Wynne High School">Wynne High School</option>' +
                '<option value="Yellville-Summit High School">Yellville-Summit High School</option>' +
                '</optgroup>' +
                '</select>').setOrigin(0.5, 0.5)
        this.districtContainer = this.add.container(this.scale.width / 2, this.scale.height / 12 * 7, [this.schoolBox, this.schoolText, this.schoolSelect])

        // Start button
        this.startButton = this.add.sprite(0, 0, 'ui', 'start-lg-normal').setScale(this.common.gameScale)
        this.startText = this.add.text(-32, -4, 'Play', {fontFamily: this.common.font, fontSize: 66, color: this.common.blue}).setOrigin(0.5)
        this.startButtonContainer = this.add.container(this.scale.width / 12 * 10 + 6, this.scale.height / 12 * 11, [this.startButton, this.startText])

        this.nextButton = this.add.sprite(0, 0, 'ui', 'start-lg-normal').setScale(this.common.gameScale);
        this.nextText = this.add.text(-32, -4, 'Next', {
            fontFamily: this.common.font,
            color: this.common.blue,
            fontSize: 66
        }).setOrigin(0.5)
        this.nextButtonContainer = this.add.container(this.scale.width / 12 * 10 + 6, this.scale.height / 12 * 11, [this.nextButton, this.nextText])
        this.nextButton.setInteractive({cursor: 'pointer'})
        this.nextButton.on('pointerdown', (event) => {
            if(this.progress === 0){
                if(this.district === ''){
                    if(this.warningText) {
                       this.warningText.setVisible(true);
                    }else{
                        this.warningText = this.add.text(this.scale.width / 2, this.scale.height / 12 * 3, 'Please choose a school district', {
                            fontFamily: this.common.font,
                            fontSize: 56,
                            color: '#ff0000'
                        }).setOrigin(0.5).setResolution(this.common.gameScale)
                    }
                    let errorClick = this.sound.add('button-click-error', {volume: 0.25});
                    errorClick.play();
                    return;
                }else{
                    this.nextSFX.play();
                    if(this.warningText) this.warningText.setVisible(false)
                    this.progress++;
                    this.isTransitioning = true;
                    return;
                }
            }
            this.nextSFX.play();
            if(this.progress === 1){
                this.progress++;
                this.isTransitioning = true;
            }
        })
        this.nextButton.on('pointerover', (event) => {
            this.nextButton.setTexture('ui', 'start-lg-hover')
            this.tweens.add({
                targets: this.nextButton,
                scale: 4.2,
                duration: 100,
                ease: 'easeOutCubic',
                repeat: 0
            })
        })
        this.nextButton.on('pointerout', (event) => {
            this.nextButton.setTexture('ui', 'start-lg-normal')
            this.tweens.add({
                targets: this.nextButton,
                scale: 4,
                duration: 100,
                ease: 'easeOutCubic',
                repeat: 0
            })
        })

        let districtSelect = document.getElementById('districtSelect');
        districtSelect.addEventListener('change', (event) => {
            this.district = districtSelect.value;
            this.acceptSFX.play();
        })

        this.nameSubmitButton.on('pointerdown', () => {
            this.username = this.nameGenerator.generateName();
            this.nameText.setText(this.username);
            this.acceptSFX.play();
        })
        this.nameSubmitButton.on('pointerover', (event) => {
            this.nameSubmitButton.setTexture('ui', 'refresh-hover').setOrigin(0.5);
            this.tweens.add({
                targets: this.nameSubmitButton,
                scale: 3 * 1.05,
                duration: 100,
                ease: 'easeOutCubic',
                repeat: 0
            })
        })
        this.nameSubmitButton.on('pointerout', (event) => {
            this.nameSubmitButton.setTexture('ui', 'refresh-normal').setOrigin(0.5);
            this.tweens.add({
                targets: this.nameSubmitButton,
                scale: 3,
                duration: 100,
                ease: 'easeOutCubic',
                repeat: 0
            })
        })

        this.startButton.setInteractive({cursor: 'pointer'})
        this.startButton.on('pointerdown', this.handleStartButton)
        this.startButton.on('pointerover', (event) => {
            this.startButton.setTexture('ui', 'start-lg-hover')
            this.tweens.add({
                targets: this.startButton,
                scale: 4.2,
                duration: 100,
                ease: 'easeOutCubic',
                repeat: 0
            })
        })
        this.startButton.on('pointerout', (event) => {
            this.startButton.setTexture('ui', 'start-lg-normal')
            this.tweens.add({
                targets: this.startButton,
                scale: 4,
                duration: 100,
                ease: 'easeOutCubic',
                repeat: 0
            })
        })

        this.backButtonColor.setInteractive({cursor: 'pointer'})
        this.backButtonColor.on('pointerdown', this.handleBackButtonColor)

        this.forwardButtonColor.setInteractive({cursor: 'pointer'})
        this.forwardButtonColor.on('pointerdown', this.handleForwardButtonColor)

        this.forwardButtonCar.setInteractive({cursor: 'pointer'})
        this.forwardButtonCar.on('pointerdown', this.moveToNextCar)

        this.backButtonCar.setInteractive({cursor: 'pointer'})
        this.backButtonCar.on('pointerdown', this.moveToPreviousCar)

        let selectButtons = [this.backButtonColor, this.forwardButtonColor, this.forwardButtonCar, this.backButtonCar]
        for(let i = 0; i < selectButtons.length; i++){
            selectButtons[i].on('pointerover', (event) => {
                this.tweens.add({
                    targets: selectButtons[i],
                    scale: 4.4,
                    duration: 100,
                    ease: 'easeOutCubic',
                    repeat: 0
                })
            })
            selectButtons[i].on('pointerout', (event) => {
                this.tweens.add({
                    targets: selectButtons[i],
                    scale: 4,
                    duration: 100,
                    ease: 'easeOutCubic',
                    repeat: 0
                })
            })
        }

        let uiScene = this.scene.get('Ui')
        uiScene.events.on('showing-help-modal', (event) => {
            this.schoolSelect.setVisible(false);
        })
        uiScene.events.on('hiding-help-modal', (event) => {
            this.schoolSelect.setVisible(true);
        })
        uiScene.events.on('soundSettingChange', (data) => {
            if(data.soundOn){
                this.sound.mute = false;
            }else{
                this.sound.mute = true;
            }
        })
        // const queryString = window.location.search;
        // const urlParams = new URLSearchParams(queryString);
        // this.district = urlParams.get('district'); // Returns "john"
        // if(this.district){
            // this.progress = 1;
            // this.moveContainerOffscreen(this.districtContainer);
            // this.nameContainer.setVisible(true);
            // this.moveContainerMidscreen(this.nameContainer);

        //}
    }

    moveToNextCar = () => {
        if (!this.carSelectionActive) {
            this.acceptSFX.play();
            this.carSelectionActive = true;
            this.events.emit('moveToNextCar')
        }
    }

    moveToPreviousCar = () => {
        if (!this.carSelectionActive) {
            this.acceptSFX.play();
            this.carSelectionActive = true;
            this.events.emit('moveToPreviousCar')
        }
    }

    handleStartButton = () => {
        if (!this.username) {
            this.add.text(this.scale.width / 2, this.scale.height / 12 * 3, 'Please choose a username', {
                fontFamily: this.common.font,
                fontSize: 14,
                color: '#ff0000'
            }).setOrigin(0.5).setResolution(this.common.gameScale)
            return;
        }

        this.nextSFX.play();
        this.moveContainerOffscreen(this.chooseCarContainer)
        this.startButtonContainer.setVisible(false);

        this.events.emit('moveToStartingPosition')
        this.scrollingScene.cameras.main.zoomTo(1, 1000);
        this.carSelectionScene.cameras.main.zoomTo(1, 1000);
        this.tweens.add({
            targets: this.music,
            volume: 0,
            duration: 1000,
            ease: 'Linear',
            yoyo: false,
            repeat: 0,
            onComplete: () => {
                this.time.delayedCall(1000, () => {
                    this.events.emit('startGame');
                    this.music.stop();
                    let carSelectionScene = this.scene.get('CarSelection');
                    carSelectionScene.removeExtras();
                    this.scene.stop('CarSelection')
                    this.scene.stop('SelectionScene')
                    if(!this.scene.get('Quiz')){
                        this.scene.add('Quiz', Quiz)
                    }
                    this.scene.start('Quiz', {
                        player: new Player(this.district, this.username, this.carSelectionScene.selectedCar),
                    });
                });
            }
        });

    }



    handleBackButtonColor = () => {
        if (!this.carSelectionActive) {
            this.acceptSFX.play();
            this.carSelectionActive = true;
            this.events.emit('moveToPreviousColor')
        }
    }

    handleForwardButtonColor = () => {
        if (!this.carSelectionActive) {
            this.acceptSFX.play();
            this.carSelectionActive = true;
            this.events.emit('moveToNextColor')
        }
    }

    moveContainerOffscreen = (container) => {
        this.tweens.add({
            targets: container,
            x: this.scale.width * 1.25,
            ease: 'Sine.easeIn',
            duration: 500,
            repeat: 0,
            onComplete: () => {
                container.setVisible(false);
            }
        })
    }

    moveContainerMidscreen = (container) => {
        this.tweens.add({
            targets: container,
            x: this.scale.width / 2,
            ease: 'Sine.easeOut',
            duration: 800,
            repeat: 0,
        })
    }

    update(){
        if(this.isTransitioning) {
            if(this.progress === 1){
                this.moveContainerOffscreen(this.districtContainer);
                this.nameContainer.setVisible(true);
                this.moveContainerMidscreen(this.nameContainer);
            }
            if(this.progress === 2){
                this.moveContainerOffscreen(this.nameContainer);
                this.chooseCarContainer.setVisible(true);
                this.moveContainerMidscreen(this.chooseCarContainer);
                this.nextButtonContainer.setVisible(false);
                this.startButtonContainer.setVisible(true);
            }
            this.isTransitioning = false;
        }
    }
}

export default SelectionScene;